/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/widgets/favourite-menu-buttons/dashboard.widgets.favourite-menu-buttons.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {FavMenuButtonService} from '../../../main-menu/services/fav-menu-button.service';
import {MainMenuButtonConfig} from '../../../../models/main-menu-button-config';
import {AppMenuButtonService} from '../../../../services/app.menu-button.service';
import {takeUntil} from 'rxjs/operators';
import {AppDialogsService} from '../../../../services/app.dialogs.service';

/**
 * Zweck: Beschreibt class DashboardWidgetsFavouriteMenuButtonsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-dashboard-widgets-favourite-menu-buttons',
    templateUrl: 'dashboard.widgets.favourite-menu-buttons.component.html',
    styleUrls: ['dashboard.widgets.favourite-menu-buttons.component.scss'],
    standalone: false
})
export class DashboardWidgetsFavouriteMenuButtonsComponent implements OnInit, OnDestroy {
  static id = 'DashboardWidgetsFavouriteMenuButtonsComponent';
  static label = 'Schnellzugriff';
  static description = 'Zeigt Ihre Favoriten an.';
  static cols = 6;
  static rows = 6;

  _destroy = new Subject();

  buttons = new BehaviorSubject<MainMenuButtonConfig[]>([]);


  favids: any;


/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private favbsvc: FavMenuButtonService, private mbsvc: AppMenuButtonService, private dsvc: AppDialogsService) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.favbsvc.favIds.pipe(takeUntil(this._destroy)).subscribe(favids => {
      this.favids = favids;
      this.renderButtons();
    });
    this.mbsvc.mainMenuConfig.pipe(takeUntil(this._destroy)).subscribe(vmb => {
      this.renderButtons();
    });
  }

/**
 * Beschreibt Methode reset und ihren Rückgabevertrag.
 */
  reset() {
    this.dsvc.confirm('zuruecksetzen', 'Auf Standard zurücksetzen', 'Wollen Sie den Schnellzugriff zurücksetzen?', () => {
      this.favbsvc.reset();
    });
  }

/**
 * Beschreibt Methode renderButtons und ihren Rückgabevertrag.
 */
  renderButtons() {
    if (this.favids) {
      const all = this.mbsvc.all();

      const buttons = [];

      this.favids.forEach(id => {
        all.forEach((b) => {
          if (b.id == id) {
            buttons.push(b);
          }
        });
      });

      this.buttons.next(buttons);
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._destroy.next(true);
    this._destroy.complete();
  }
}
